<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col-md-4 left">
          <div class="title">
            {{ $t('sidebar.configuration') }} > {{ $t('sidebar.notifications') }}
          </div>
        </div>
      </div>
    </div>
    <div class="content col-md-12">
      <channel-notification
        :app_id="1"
        :code="['100', '110', '140', '170']"/>
    </div>
    <BaseModalOverLimit
      :id="modalFeeAlert"
      :headerText="$t('overlimit.linemessage.header')"
      :bodyTextUnitPrice="$t('overlimit.linemessage.body.unitprice', { number: getCurrencyWithNumber(numberel(pricing.messageLine, '0,0.[000000]')) })"
      :bodyTextPerMonth="$t('overlimit.linemessage.body.permonth', { number: numberel(shopUseLimit.messageLine, '0,0') })"
    />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import ChannelNotification from '@/components/custom/ChannelNotification.vue'
import sidebarModule from './../../sidebarModule'

export default {
  name: 'PosConfigurationNotification',
  components: {
    ChannelNotification,
  },
  data () {
    return {
      modalFeeAlert: 'modalFeeAlert',
    }
  },
  computed: {
    ...mapGetters({
      shopUseLimit: 'getShopUseLimit',
    }),
    ...mapState('treesoft', {
      pricing: 'pricing',
    }),
  },
  beforeMount: function () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.pos.title'),
      current: {
        app_name: 'pos',
        app_id: 1,
        module_id: 4,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 4,
      submenuAtIdx: 1,
    })
  },
  async mounted () {
    await this.fetchData()
    $(`#${this.modalFeeAlert}`).modal('show')
  },
  methods: {
    ...mapActions([
      'getShopUseLimit',
    ]),
    ...mapActions('treesoft', {
      getPricing: 'getPricing',
    }),
    async fetchData () {
      this.ready = false
      await Promise.all([
        this.getShopUseLimit(),
        this.getPricing(),
      ])
      this.ready = true
      this.showFinish(this.$Progress)
    },
  },
  destroyed: function () {
    this.leavePage(this.$Progress, [])
  },
}
</script>



// WEBPACK FOOTER //
// src/components/apps/pos/configuration/Notification.vue